import FormField from "components/FormField";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";
import SoftMultiSelect from 'components/SoftMultiSelect'
import Grid from "@mui/material/Grid";
import { useAgencyInfo } from "context/agency";
import { useDeleteAssistant } from "queries/assistants";

import { FormControlLabel, Icon, Switch } from '@mui/material';

function ModalComponent({ open, onClose, item, handleRefresh }) {
  const { mutateAsync: deleteAssistant } = useDeleteAssistant();

  const deleteassistant = async (item) => {
    const { response } = await deleteAssistant(`_id=${item._id}&assistant_id=${item.assistant_id}`);
    if (response) {
      onClose();
    }
  }
  return (<>

    {open &&
      <div className="modal-zz-confirm text-left">

        <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>

          <span className='crossison' onClick={onClose}>X</span>
          <SoftBox>
            <SoftTypography>Are you sure you want to delete {`"${item?.assistant_name}"`} </SoftTypography>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center">
              <SoftButton
                variant="outlined"
                color="dark"

                sx={{ mt: 4, mb: 1, mr: 2 }}
                onClick={() => deleteassistant(item)}
                fullWidth
              >
                Yes
              </SoftButton>
              <SoftButton
                variant="outlined"
                color="error"
                sx={{ mt: 4, mb: 1, ml: 2 }}
                onClick={onClose}
                fullWidth
              >
                Cancel
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </div>
      </div>
    }
  </>
  );
}
ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
  products: PropTypes.array,
  apps: PropTypes.array,
};
function Modal({ item, handleRefresh }) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <>

      <p className="cursor-pointer" onClick={() => setOpenAddMember(true)}><Icon>delete</Icon></p>

      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        item={item}
        handleRefresh={handleRefresh}
      />

    </>
  );
}
Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};
export default Modal;
